import { SvgIcon } from '@mui/material';
import { RoutalPalette } from '@nx-smartmonkey/ui';

export default function RequirementsIcon(props: any) {
  return (
    <SvgIcon
      {...props}
      viewBox="0 0 14.17 17.39"
      style={{ width: `16px`, height: `16px`, color: RoutalPalette.grey1, ...props.style }}
    >
      <g>
        <path d="M1.94,3.63c-.13,0-.26-.05-.35-.15L.25,2.15C.05,1.95.05,1.63.25,1.44s.51-.2.71,0l.98.98L4.03.34c.2-.2.51-.2.71,0s.2.51,0,.71l-2.44,2.44c-.1.1-.23.15-.35.15Z" />
        <path d="M13.44,2.41h-6.95c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.95c.28,0,.5.22.5.5s-.22.5-.5.5Z" />
        <path d="M1.94,10.44c-.13,0-.26-.05-.35-.15l-1.34-1.34c-.2-.2-.2-.51,0-.71s.51-.2.71,0l.98.98,2.09-2.09c.2-.2.51-.2.71,0s.2.51,0,.71l-2.44,2.44c-.1.1-.23.15-.35.15Z" />
        <path d="M13.44,9.22h-6.95c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.95c.28,0,.5.22.5.5s-.22.5-.5.5Z" />
        <path d="M1.94,17.25c-.13,0-.26-.05-.35-.15l-1.34-1.34c-.2-.2-.2-.51,0-.71s.51-.2.71,0l.98.98,2.09-2.09c.2-.2.51-.2.71,0s.2.51,0,.71l-2.44,2.44c-.09.09-.22.15-.35.15Z" />
        <path d="M13.44,16.03h-6.95c-.28,0-.5-.22-.5-.5s.22-.5.5-.5h6.95c.28,0,.5.22.5.5s-.22.5-.5.5Z" />
      </g>
    </SvgIcon>
  );
}
